import React from "react";

const CloseIcon = (props: any) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>close-icon</title>
      <path
        d="M6.586 8L.293 1.707c-.39-.39-.39-1.024 0-1.414.39-.39 1.024-.39 1.414 0L8 6.586 14.293.293c.39-.39 1.024-.39 1.414 0 .39.39.39 1.024 0 1.414L9.414 8l6.293 6.293c.39.39.39 1.024 0 1.414-.39.39-1.024.39-1.414 0L8 9.414l-6.293 6.293c-.39.39-1.024.39-1.414 0-.39-.39-.39-1.024 0-1.414L6.586 8z"
        fill="#000"
        fillRule="evenodd"
      />
    </svg>
  );
};

export default CloseIcon;
